import React from "react";

const addPerson = 
    <svg xmlns="http://www.w3.org/2000/svg" 
    width="18"
    height="16"
    viewBox="0 0 24 22">
      <g transform="translate(-4)">
        <circle cx="10.99" cy="3" r="3"></circle>
        <path d="M11 8a8 8 0 00-6.33 3.11A3 3 0 007 16h8a3 3 0 002.31-4.89A8 8 0 0011 8zm10-3h-1V4a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0V7h1a1 1 0 000-2z"></path>
      </g>
    </svg>


export default addPerson;
